import { PORTFOLIO_OVERVIEW_ID } from "testIds";
import React, { ReactNode } from "react";
import OverviewPanel from "common/NewLook/OverviewPanel.tsx";

/** The portfolio pages chart no prices, so their overview sits lower. */
export const PORTFOLIO_OVERVIEW_HEIGHT = 260;

interface NewLookOverviewProps {
  allocationTitle: ReactNode;
  /** A bare `AllocationCard` (no border, no title). */
  allocation: ReactNode;
  chart: ReactNode;
}

/** The portfolio pages' overview: the shared overview panel, with a test id. */
const NewLookOverview = (props: NewLookOverviewProps) => (
  <OverviewPanel
    {...props}
    zoneHeight={PORTFOLIO_OVERVIEW_HEIGHT}
    data-testid={PORTFOLIO_OVERVIEW_ID}
  />
);

export default NewLookOverview;
